/**
 * @see https://www.w3schools.com/tags/att_button_type.asp
 */
export enum CtaButtonTypeEnum {
  Button = 'button',
  Reset = 'reset',
  Submit = 'submit',
}
